// AX: product image magnifier. On mouse/trackpad devices the zoom starts as soon as the pointer
// is over the image and follows it; on touch devices it still opens with a tap.
let overlay = null;

function prepareOverlay(container, src) {
  container.setAttribute('class', 'image-magnify-full-size');
  container.setAttribute('aria-hidden', 'true');
  container.style.backgroundImage = `url('${src}')`;
  container.style.backgroundColor = 'var(--gradient-background)';
}

function moveWithHover(image, event, zoomRatio) {
  if (!overlay) return;
  const ratio = image.height / image.width;
  const rect = image.getBoundingClientRect();
  const xPercent = `${(event.clientX - rect.left) / (image.clientWidth / 100)}%`;
  const yPercent = `${(event.clientY - rect.top) / ((image.clientWidth * ratio) / 100)}%`;
  overlay.style.backgroundPosition = `${xPercent} ${yPercent}`;
  overlay.style.backgroundSize = `${image.width * zoomRatio}px`;
}

function removeOverlay() {
  if (!overlay) return;
  overlay.remove();
  overlay = null;
}

function magnify(image, zoomRatio, event) {
  removeOverlay();
  const el = document.createElement('div');
  const src = image.src;
  prepareOverlay(el, src);
  overlay = el;
  if (event) moveWithHover(image, event, zoomRatio);

  el.onmousemove = (e) => moveWithHover(image, e, zoomRatio);
  el.onmouseleave = removeOverlay;
  el.onclick = removeOverlay;

  const loader = new Image();
  loader.onload = () => {
    if (overlay !== el || !image.parentElement) return;
    image.parentElement.insertBefore(el, image);
  };
  loader.src = src;
}

function enableZoomOnHover(zoomRatio) {
  const canHover = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  document.querySelectorAll('.image-magnify-hover').forEach((image) => {
    if (canHover) {
      image.onclick = null;
      image.onmouseenter = (event) => magnify(image, zoomRatio, event);
      image.onmousemove = (event) => moveWithHover(image, event, zoomRatio);
      image.onmouseleave = () => {
        // pointer left before the zoomed image finished loading
        if (overlay && !overlay.isConnected) removeOverlay();
      };
    } else {
      image.onclick = (event) => magnify(image, zoomRatio, event);
    }
  });
}

enableZoomOnHover(1.5);